module.exports = __webpack_public_path__ + "static/media/Total_Orders.5a88d274.png";